"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.telemetryTreeWalker = void 0;
var telemetryFilter_1 = require("./filter/telemetryFilter");
var telemetryConstants_1 = require("./telemetryConstants");
var INVALID_NODE_TYPES = [
    'SCRIPT',
    'NOSCRIPT',
    'STYLE',
    'CANVAS',
    'IMG',
    'META',
    'VIDEO',
    'INPUT',
    'IFRAME',
    'TEXTAREA'
];
var EXCLUDE_CATEGORY = [
    "StoreLayoutListContainer",
    "card.store",
    "LegoStandardCarouselContainer"
];
function getClosestTag(node) {
    if (node.nodeType == Node.ELEMENT_NODE && (node.getAttribute('data-anchor-id') || node.getAttribute('data-testid'))) {
        return node.getAttribute('data-anchor-id') || node.getAttribute('data-testid');
    }
    else if (node.parentNode)
        return getClosestTag(node.parentNode);
    //return root for default
    else
        return telemetryConstants_1.DEFAULT_TAG;
}
function telemetryTreeWalker(entryNode, nodesMap) {
    var _a, _b;
    var treeWalker = document.createTreeWalker(entryNode, NodeFilter.SHOW_TEXT);
    var _loop_1 = function () {
        if (INVALID_NODE_TYPES.indexOf((_b = (_a = treeWalker === null || treeWalker === void 0 ? void 0 : treeWalker.currentNode) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.tagName) === -1) {
            var capturedText = treeWalker.currentNode.nodeValue;
            var textTag_1 = getClosestTag(treeWalker.currentNode);
            if (EXCLUDE_CATEGORY.indexOf(textTag_1) !== -1)
                return "continue";
            var textList = capturedText.split('•');
            textList.forEach(function (text) {
                text = text.trim();
                //insert into the map that collecting the tag and textContent
                if (!(0, telemetryFilter_1.mainFilter)(text)) {
                    nodesMap.insertTextByCategory(textTag_1, text);
                }
            });
        }
    };
    while (treeWalker.nextNode()) {
        _loop_1();
    }
}
exports.telemetryTreeWalker = telemetryTreeWalker;
